<script>
import MedicalRecordsPanel from "@/views/pages/medical-records/MedicalRecordsPanel.vue";

export default {
  name: "ResponsiblePersonDetail",
  components: { MedicalRecordsPanel },
  props: {
    currentResponsible: {
      type: Object,
      default: null,
    },
  },
  computed: {
    responsible() {
      return this.currentResponsible && this.currentResponsible.id
        ? this.currentResponsible
        : null;
    },
  },
  methods: {
    display(v) {
      if (v === null || v === undefined || v === "") return "—";
      return v;
    },
  },
};
</script>

<template>
  <div class="responsible-person-detail">
    <div v-if="!responsible" class="text-center py-4 text-muted">
      Nenhum responsável carregado. Use Visualizar na listagem.
    </div>

    <div v-else>
      <div class="mb-3">
        <h5 class="mb-1">{{ responsible.name }}</h5>
        <b-badge variant="light">ID {{ responsible.id }}</b-badge>
      </div>

      <b-tabs pills content-class="mt-3">
        <b-tab title="Dados gerais">
          <ul class="list-unstyled mb-0">
            <li class="mb-2">
              <span class="text-muted">Celular:</span>
              <strong class="ml-1">{{ display(responsible.celular) }}</strong>
            </li>
            <li class="mb-2">
              <span class="text-muted">E-mail:</span>
              <strong class="ml-1">{{ display(responsible.email) }}</strong>
            </li>
            <li class="mb-2">
              <span class="text-muted">CPF:</span>
              <strong class="ml-1">{{ display(responsible.cpf) }}</strong>
            </li>
            <li>
              <span class="text-muted">Ativo:</span>
              <strong class="ml-1">{{ responsible.status === 1 ? "Sim" : "Não" }}</strong>
            </li>
          </ul>
        </b-tab>

        <b-tab :title="$t('menuitems.prontuarios.text')" lazy>
          <MedicalRecordsPanel entity-type="responsible" :entity-id="responsible.id" />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
